import kendo from '@progress/kendo-ui'
import formatConverter from './formatConverter.js'
import extendFormula from './extendSpreadFunction.js'

var CellRef = kendo.spreadsheet.CellRef
var RangeRef = kendo.spreadsheet.RangeRef

export default {
  defineFunctions(kendoObj) {
    // 数值转财务中文
    kendoObj.spreadsheet.defineFunction('CAmount', this.CAmount).args([
      ['amount', ['or', 'anyvalue', 'null', 'area']],
      ['outPutType', ['or', 'anyvalue', 'null']]
    ])
    // 日期间隔
    kendoObj.spreadsheet.defineFunction('DateDif', this.DateDif).args([
      ['start_date', 'datetime'],
      ['end_date', 'datetime'],
      ['interval', 'anyvalue']
    ])
    // 根据分隔符计算数量
    kendoObj.spreadsheet.defineFunction('ItemCount', this.ItemCount).args([
      ['string', 'string'],
      ['splitStr', 'anyvalue']
    ])
    // 替换字符串
    kendoObj.spreadsheet.defineFunction('ReplaceStr', this.ReplaceStr).args([
      ['string', 'string'],
      ['substr', 'string'],
      ['replacement', ['or', 'string', 'null']]
    ])
    // 合并区域数据
    kendoObj.spreadsheet.defineFunction('Join', this.Join).args([
      ['string', 'area'],
      ['separator', ['or', 'anyvalue', 'null']],
      ['direction', ['or', 'anyvalue', 'null']]
    ])
    // 合并区域数据
    kendoObj.spreadsheet.defineFunction('PJoin', this.PJoin).args([
      ['string', 'area'],
      ['separator', ['or', 'anyvalue', 'null']],
      ['direction', ['or', 'anyvalue', 'null']]
    ])
    // 获得周几信息
    kendoObj.spreadsheet.defineFunction('WWeekday', this.WWeekday).args([
      ['date', ['or', 'anyvalue', 'null', 'area']]
    ])
    // 偏移单元格相对位置
    kendoObj.spreadsheet.defineFunction('ShiftCell', this.ShiftCell).args([
      ['horShift', ['or', 'number', 'null']],
      ['verShift', ['or', 'number', 'null']]
    ])
    // 合计不带公式单元格
    kendoObj.spreadsheet.defineFunction('SumX', this.SumX).args([
      ['calcArea', 'area']
    ])
    // 合计不带公式单元格
    kendoObj.spreadsheet.defineFunction('SumifX', this.SumifX).args([
      ['compareArea', 'area'],
      ['compareCell', 'anyvalue'],
      ['numbers', 'area']
    ])
    // 分组小计
    kendoObj.spreadsheet.defineFunction('SubtotalX', this.SubtotalX).args([
      ['compareArea', 'area'],
      ['numbers', 'area'],
      ['subTotoleType', ['or', 'number', 'null']]
    ])
    // 取当前字段整列数据
    kendoObj.spreadsheet.defineFunction('WholeData', this.WholeData).args([
      ['ref', ['or', 'area', 'null']]
    ])
    //
    kendoObj.spreadsheet.defineFunction('AutoWipe', this.AutoWipe).args([
      ['total', 'number'],
      ['numberRef', ['or', 'area', 'null']]
    ])
    // 身份证生日
    kendoObj.spreadsheet.defineFunction('GetBirthday', this.GetBirthday).args([
      ['id_number', 'anyvalue']
    ])
    // 身份证性别
    kendoObj.spreadsheet.defineFunction('GetSex', this.GetSex).args([
      ['id_number', 'anyvalue'],
      ['output', ['or', 'number', 'null']]
    ])
    // 序号
    kendoObj.spreadsheet.defineFunction('Order', this.OrderNumber).args([
      ['compareCell', 'area']
    ])
    // 字节数量
    kendoObj.spreadsheet.defineFunction('LenB', this.GetLenB).args([
      ['character', ['or', 'string', 'area']]
    ])
    // 图片附件是否有值
    kendoObj.spreadsheet.defineFunction('HasValue', this.HasValue).args([
      ['value', 'area']
    ])
  },
  DateDif: function (start_date, end_date, interval) {
    start_date = formatConverter.serialToDate(start_date)
    end_date = formatConverter.serialToDate(end_date)
    var long = end_date.getTime() - start_date.getTime() // 相差毫秒
    switch (interval) {
      case 'Y': case 'y': return parseInt(end_date.getFullYear() - start_date.getFullYear())
      case 'M': return parseInt((end_date.getFullYear() - start_date.getFullYear()) * 12 + (end_date.getMonth() - start_date.getMonth()))
      case 'D': case 'd': return parseInt(long / 1000 / 60 / 60 / 24)
      case 'W': case 'w': return parseInt(long / 1000 / 60 / 60 / 24 / 7)
      case 'H': case 'h': return parseInt(long / 1000 / 60 / 60)
      case 'm': return parseInt(long / 1000 / 60)
      case 'S': case 's': return parseInt(long / 1000)
      case 'L': case 'l': return parseInt(long)
    }
  },
  ItemCount: function (string, splitStr) {
    if (!string) {
      return ''
    }
    var splitResult = string.split(splitStr)
    return splitResult ? splitResult.length : 0
  },
  ReplaceStr: function (string, substr, replacement) {
    replacement = replacement || ''
    var reg = new RegExp(substr, 'g')
    return string.replace(reg, replacement)
  },
  CAmount: function (number, outPutType) {
    if (number instanceof Array) {
      if (number.length === 0) {
        return ''
      } else {
        number = number[0]
      }
    }
    if (!number && number !== 0) {
      return ''
    }
    if (number instanceof kendo.spreadsheet.CalcError) {
      return kendo.spreadsheet.CalcError('DIV/0')
    }
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(number)) { return kendo.spreadsheet.CalcError('DIV/0') }
    if (parseFloat(number) === 0) {
      return '零元整'
    }
    switch (outPutType) {
      case 2:
      case '2':
      default:
        // 金额大写
        var unit = '京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元角分'
        var str = ''
        number += '00'
        var p = number.indexOf('.')
        if (p >= 0) { number = number.substring(0, p) + number.substr(p + 1, 2) }
        unit = unit.substr(unit.length - number.length)
        for (var i = 0; i < number.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i)
        return str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(兆|万|亿|元)/g, '$1').replace(/(兆|亿)万/g, '$1').replace(/(京|兆)亿/g, '$1').replace(/(京)兆/g, '$1').replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, '$1$2零$3仟').replace(/^元零?|零分/g, '').replace(/(元|角)$/g, '$1整')
    }
  },
  PJoin: function (range, separator, direction) {
    if (range instanceof kendo.spreadsheet.RangeRef) {
      var valueArray = []
      var rangeArray = []
      if (direction) {
        range.forEachRow(row => {
          row.sheet = range.sheet
          rangeArray.push(row)
        })
      } else {
        range.forEachColumn(col => {
          col.sheet = range.sheet
          rangeArray.push(col)
        })
      }
      for (var item of rangeArray) {
        valueArray.push.apply(valueArray, this.getRefData(item))
      }
      separator = separator || ','
      return valueArray.join(separator)
    }
  },
  Join: function (range, separator, direction) {
    if (range instanceof kendo.spreadsheet.RangeRef) {
      var valueArray = []
      var rangeArray = []
      if (direction) {
        range.forEachRow(row => {
          row.sheet = range.sheet
          rangeArray.push(row)
        })
      } else {
        range.forEachColumn(col => {
          col.sheet = range.sheet
          rangeArray.push(col)
        })
      }
      for (var item of rangeArray) {
        valueArray.push.apply(valueArray, this.getRefData(item))
      }
      separator = separator || ','
      return valueArray.join(separator)
    }
  },
  WWeekday: function (date) {
    if (!date) {
      return ''
    }
    try {
      if (date instanceof Array) {
        if (date.length === 0) {
          return ''
        } else {
          date = date[0]
        }
      }
      date = new Date((date - (25567 + 2)) * 86400 * 1000)
    } catch (ex) {
      return kendo.spreadsheet.CalcError('#NAME?')
    }
    if (date instanceof Date) {
      var weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      return weekdays[date.getDay()]
    } else {
      return kendo.spreadsheet.CalcError('#NAME?')
    }
  },
  // 偏移
  ShiftCell: function (horShift, verShift) {
    var currentRow = this.formula.row + (horShift || 0)
    var currentCol = this.formula.col + (verShift || 0)
    var currentSheetName = this.formula.sheet
    var sheet = this.workbook().sheetByName(currentSheetName)
    return sheet.range(currentRow, currentCol).value()
  },
  // 合计不带公式单元格
  SumX: function (calcArea) {
    var currentSheetName = calcArea.sheet
    var sheet = this.workbook().sheetByName(currentSheetName)
    var calcArray = []
    sheet.range(calcArea).forEachCell((row, col, cell) => {
      if (!cell.formula) {
        calcArray.push(parseFloat(cell.value))
      }
    })
    if (calcArray.length) {
      return calcArray.reduce((total, num) => {
        return total + num
      })
    } else {
      return 0
    }
  },
  // 判断合计不带公式单元格
  // subTotoleType=1 左like匹配
  SumifX: function (compareArea, compareCell, numbers, subTotoleType, workbookRef) {
    if (!numbers) {
      numbers = compareArea
    }
    // 两个区域必须同一个sheet
    if (!compareArea.sheet) {
      return kendo.spreadsheet.CalcError('REF')
    }
    if (compareArea.sheet !== numbers.sheet) {
      return kendo.spreadsheet.CalcError('REF')
    }
    // if(sourceValue===undefined||sourceValue===null){
    //   return kendo.spreadsheet.CalcError('REF')
    // }
    // 判断compareArea方向
    var direction = -1
    if (compareArea.topLeft.row === compareArea.bottomRight.row) {
      // 向右
      direction = 0
    } else if (compareArea.topLeft.col === compareArea.bottomRight.col) {
      // 向下
      direction = 1
    } else {
      return kendo.spreadsheet.CalcError('REF')
    }
    var currentSheetName = compareArea.sheet
    var sheet = (workbookRef || this.workbook()).sheetByName(currentSheetName)
    var calcArray = []
    var calcRange
    // var sourceValue=compareCell.toString()
    sheet.range(compareArea).forEachCell((row, col, cell) => {
      if (!cell.value && cell.value !== 0) {
        return
      }
      var compareVal = cell.value.toString()
      if (subTotoleType ? compareVal.indexOf(compareCell) === 0 : compareVal === compareCell) {
        if (direction) {
          // 向下
          calcRange = sheet.range(formatConverter.ConvertJsonToRange({
            topLeft: {
              row: row + 1,
              col: numbers.topLeft.col + 1
            },
            bottomRight: {
              row: row + 1,
              col: numbers.bottomRight.col + 1
            }
          }))
        } else {
          // 向右
          calcRange = sheet.range(formatConverter.ConvertJsonToRange({
            topLeft: {
              row: numbers.topLeft.row + 1,
              col: col + 1
            },
            bottomRight: {
              row: numbers.bottomRight.row + 1,
              col: col + 1
            }
          }))
        }
        calcRange.forEachCell((r1, c1, calcCell) => {
          if (!calcCell.formula) {
            calcArray.push(parseFloat(calcCell.value))
          }
        })
      }
    })
    if (calcArray.length) {
      return calcArray.reduce((total, num) => {
        return total + num
      })
    } else {
      return 0
    }
  },
  // 分组小计
  SubtotalX: function (compareArea, numbers, subTotoleType) {
    var currentSheetName = compareArea.sheet
    var sheet = this.workbook().sheetByName(currentSheetName)
    var compareValue = sheet.range(this.formula.row, compareArea.topLeft.col).value()
    return extendFormula.SumifX(compareArea, compareValue, numbers, subTotoleType, this.workbook())
  },
  // 取当前字段整列数据
  WholeData: function (ref, workbookRef) {
    try {
      var currentSheetName
      if (ref instanceof RangeRef) {
        currentSheetName = ref.sheet
        ref = ref.topLeft
      } else if (!(ref instanceof CellRef)) {
        ref = this.formula
      }
      currentSheetName = currentSheetName || ref.sheet
      var workbook = workbookRef || this.workbook()
      var sheet = workbook.sheetByName(currentSheetName)
      var cellRange = formatConverter.ConvertAllFormat2Json(new CellRef(ref.row, ref.col), { activeSheet: currentSheetName })
      var range = extendFormula.GetRangeInNameRange(cellRange, currentSheetName, true, workbook)
      return new RangeRef(new CellRef(range.topLeft.row - 1, range.topLeft.col - 1), new CellRef(range.bottomRight.row - 1, range.bottomRight.col - 1)).setSheet(sheet)
    } catch (ex) {
      return kendo.spreadsheet.CalcError('CALC_ERR')
    }
  },
  GetRangeInNameRange(Json, sheetName, onlyField, workbook) {
    var tempNameRange
    for (var nameRange in workbook._names) {
      if (nameRange.substring(0, 1) !== '_') {
        continue
      }
      tempNameRange = workbook._names[nameRange].value
      if (sheetName !== undefined && sheetName !== null) {
        if (sheetName !== tempNameRange.sheet) {
          continue
        }
      }
      tempNameRange = formatConverter.ConvertAllFormat2Json(tempNameRange, { activeSheet: sheetName })
      if (tempNameRange === undefined) {
        continue
      }
      Json.workSheet = sheetName
      if (this.RangeInclude(Json, tempNameRange)) {
        tempNameRange.name = nameRange
        if (onlyField) {
          if (tempNameRange.name.substring(0, 3) === '_mt' || tempNameRange.name.substring(0, 3) === '_ct') {
            continue
          }
        }
        return tempNameRange
      }
    }
    return undefined
  },
  RangeInclude: function (range, biggerRange) {
    if (biggerRange.topLeft.row <= range.topLeft.row &&
      biggerRange.topLeft.col <= range.topLeft.col &&
      biggerRange.bottomRight.row >= range.bottomRight.row &&
      biggerRange.bottomRight.col >= range.bottomRight.col) {
      return true
    }
    return false
  },
  AutoWipe: function (total, numberRef) {
    // 1=纵向，0=横向
    var direction = numberRef.topLeft.row === numberRef.bottomRight.row ? 0 : 1
    try {
      var ownRange = extendFormula.WholeData(new CellRef(this.formula.row, this.formula.col).setSheet(this.formula.sheet), this.workbook())
      if (ownRange instanceof kendo.spreadsheet.CalcError) {
        throw new Error()
      }
    } catch (ex) {
      return kendo.spreadsheet.CalcError('REF')
    }
    var workbook = this.workbook()
    var firstLine, totalNowRange, totalNows, totalNow
    totalNow = 0
    if (direction ? this.formula.row === ownRange.topLeft.row : this.formula.col === ownRange.topLeft.col) {
      firstLine = true
    }
    if (!firstLine) {
      totalNowRange = new RangeRef(ownRange.topLeft, new CellRef(this.formula.row - (direction ? 1 : 0), this.formula.col - (!direction ? 1 : 0))).setSheet(this.formula.sheet)
      totalNows = workbook.sheetByName(this.formula.sheet).range(totalNowRange).values()
      totalNows.forEach(row => {
        row.forEach(cell => {
          if (cell) {
            totalNow += parseFloat(cell || 0)
          }
        })
      })
    }
    var valueLeft = total - totalNow
    var currentNumberCell = direction ? new CellRef(this.formula.row, numberRef.topLeft.col) : new CellRef(numberRef.topLeft.row, this.formula.col)
    var currentNumber = parseFloat(workbook.sheetByName(this.formula.sheet).range(currentNumberCell).value() || 0)
    if (valueLeft > 0) {
      if (valueLeft >= currentNumber) {
        return currentNumber
      } else {
        return valueLeft
      }
    } else {
      return 0
    }
  },
  GetBirthday: function (id_number) {
    console.log(id_number)
    if (id_number && id_number.length === 18) {
      return `${id_number.substr(6, 4)}-${id_number.substr(10, 2)}-${id_number.substr(12, 2)}`
    } else {
      return kendo.spreadsheet.CalcError('CALC_ERR')
    }
  },
  // 根据身份证号取性别
  // 男=1，女=0
  GetSex: function (id_number, output) {
    var returnValue
    if (id_number && id_number.length === 18) {
      var identifyNumber = id_number.substr(16, 1)
      returnValue = (+identifyNumber) % 2
    } else {
      return kendo.spreadsheet.CalcError('CALC_ERR')
    }
    if (output) {
      returnValue = returnValue ? '男' : '女'
    }
    return returnValue
  },
  OrderNumber: function (valueRange) {
    console.log('ordernumber')
    if (valueRange instanceof RangeRef) {
      var worksheet = this.workbook().sheetByName(this.formula.sheet)
      var currentRowCell = new CellRef(this.formula.row, valueRange.topLeft.col)
      // 下方公式重新计算一次
      if (worksheet.range(currentRowCell).value()) {
        var getCurrentNumber = (row, col) => {
          if (row > 0) {
            var prevCell = worksheet.range(new CellRef(row - 1, col))
            if (prevCell.formula() && prevCell.formula().toString().toLowerCase().indexOf('order') >= 0) {
              // 上一个单元格也是序号
              if (prevCell.value()) {
                return prevCell.value() + 1
              } else {
                return getCurrentNumber(row - 1, col)
              }
            } else {
              return 1
            }
          } else {
            return 1
          }
        }
        return getCurrentNumber(this.formula.row, this.formula.col)
      } else {
        return null
      }
    } else {
      return kendo.spreadsheet.CalcError('CALC_ERR')
    }
  },
  GetLenB: function (character) {
    var count = 0
    for (var i = 0; i < character.length; i++) {
      if ((character.charCodeAt(i) > 0 && character.charCodeAt(i) < 127) ||
        (character.charCodeAt(i) > 65376 && character.charCodeAt(i) < 65440)) {
        count++
      } else {
        count += 2
      }
    }
    return count
  },
  HasValue: function (value) {
    const sheet = this.workbook().sheetByName(value.sheet)
    var hasValue = false
    const range = sheet.range(value)
    if (range.imageGroup && range.imageGroup() && range.imageGroup().data && range.imageGroup().data.length) {
      hasValue = true
    } else if (range.attachGroup && range.attachGroup() && range.attachGroup().data && range.attachGroup().data.length) {
      hasValue = true
    } else if (range.image && range.image()) {
      hasValue = true
    } else if (range.value()) {
      hasValue = true
    }
    debugger
    return hasValue
  }
}
